import googleMapStyles from './features/google-map-styles'
import config from './config'
import contentFilters from "./features/content-filters";
import headerInteraction from "./features/header-interaction";
import generalSwiper from "./features/general-swiper";
import googleMap from "./features/google-map";
import accordionInteraction, {handleAccordionAutoOpenFromUrlHash} from "./features/accordion-interaction";
import videoModal from "./features/video-modal";
import lightbox from "./features/lightbox";

(function () {
	window.breakpoints = config.breakpoints;
	document.querySelectorAll('.js-content-filters').forEach((rootEl) => contentFilters(rootEl))
	document.querySelectorAll('.js-header').forEach((rootEl) => headerInteraction(rootEl))
	document.querySelectorAll('.js-general-swiper').forEach((rootEl) => generalSwiper(rootEl))

	document.querySelectorAll('.js-accordion-item').forEach((rootEl) => accordionInteraction(rootEl))
	document.querySelectorAll('.js-video-modal').forEach((rootEl) => videoModal(rootEl));
	document.querySelectorAll('.js-hero-video').forEach((rootEl) => lightbox(rootEl));

	void handleAccordionAutoOpenFromUrlHash()

	window.initMaps = () => {
		document.querySelectorAll('.js-google-map').forEach((rootEl) => googleMap(rootEl, googleMapStyles))
	}
})()
